export const LOCAL_KEY_USER = '@SGF_Auth:user';
export const LOCAL_KEY_TOKEN = '@SGF_Auth:token';
export const LOCAL_KEY_DARK_MODE = '@SGF_THEME:dark';
